import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';

@Component({
	selector: 'settings-breadcrumbs',
	templateUrl: './settings-breadcrumbs.component.html',
	styleUrls: ['./settings-breadcrumbs.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})

export class SettingsBreadCrumbsComponent {
	constructor (
		private routerService: RouterService
	) {}

	public goToSettings = () => {
		this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_SETTINGS);
	};
}
